import { defineStore } from "pinia"
import { useAuthStore } from "./AuthStore"
import { RosterService } from "@/services/RosterService"
import { TrainingProgramService } from "@/services/TrainingProgramService"
import { ClientGoalsService } from "@/services/ClientGoalsService"

export const useClientStore = defineStore("clientStore", {
  state: () => {
    return {
      clients: [],
      recentSearches: [],
      currentClient: null,
    }
  },
  actions: {
    async fetchClients() {
      const authStore = useAuthStore()
      const accountPrefixId = authStore.currentUser.account.prefix_id
      const trainerId = authStore.currentUser.id
      this.clients = await RosterService.fetchMergedClients({ accountPrefixId, trainerId, archived: false })
    },

    async fetchAndSetCurrentClient(participantId) {
      if (this.clients.length === 0) {
        await this.fetchClients()
      }
      const client = this.clients.find((c) => c.participantId === participantId) ?? null
      if (client) {
        // The legacy api/ client doc embedded trainingPrograms and goals;
        // the roster shape does not. Programs filter by the participant
        // roster array (stamped by the backfill / new creates); goals are
        // the latest participant-keyed goal set.
        const authStore = useAuthStore()
        const [programs, goalSets] = await Promise.all([
          TrainingProgramService.findAllByTrainer(authStore.currentUser.participantId)
            .then((res) => res.data.filter((p) => p.clientParticipantIds?.includes(participantId)))
            .catch(() => []),
          ClientGoalsService.fetchAllByClient(participantId)
            .then((res) => res.data).catch(() => []),
        ])
        client.trainingPrograms = programs
        client.goals = goalSets[0] ?? null
      }
      this.currentClient = client
    },
  },
})
